import { NgModule } from '@angular/core';

import { SharedModule} from "../../shared/shared.module";
import { SetoresComponent } from './setores.component';
import { SetorListComponent } from './setor-list/setor-list.component';
import { SetorFormComponent } from './setor-form/setor-form.component';
import { SetorApiService } from "./shared/setor-api.service";
import { SetorNavigationService } from "./shared/setor-navigation.service";
import { SetorService } from "./shared/setor.service";
import { SetoresRoutingModule} from "./setores-routing.module";

@NgModule({
  imports: [
    SharedModule,
    SetoresRoutingModule
  ],
  providers: [
    SetorApiService,
    SetorNavigationService,
    SetorService
  ],
  declarations: [
    SetoresComponent,
    SetorListComponent,
    SetorFormComponent
  ],
  exports: [
    SetorListComponent
  ]
})
export class SetoresModule { }



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/estruturas/setores/setores.module.ts
 **/